export const EMPTY_UUID: string = '00000000-0000-0000-0000-000000000000';

export const START_OF_DAY: string = 'start_of_day';
export const END_OF_DAY: string = 'end_of_day';

export const COMMENT_EDIT_TIMEOUT_MS: number = 1000 * 60 * 15;

export * from './permission.constants';
export * from './platform-security-policy.constants';
export * from './storage-keys.constants';
